export const permissions = {
  defaultRedirectUrl: '/',
  defaultPermPrefix: 'gtcx_maps',
  routes: [['/', 'read:assets']]
};
export const appName = 'maps-frontend';
export const appVersion = '1.7.15';
export const pathDatePickerTimeLimit = 90; // days back from today
